import React from 'react'
import _ from 'lodash'

import {Alert, Badge, Button, Modal} from 'antd'

import {NetworkService} from 'api/network'
import {AuthStore} from 'api/auth'

import {OrganizationStore} from 'api/organization'
export class SelectedACL extends React.Component {
   static get propTypes() {
      return {
         params:   React.PropTypes.object.isRequired,
         network:  React.PropTypes.object.isRequired,
         router:   React.PropTypes.object.isRequired,
         location: React.PropTypes.object.isRequired,
         routes:   React.PropTypes.array.isRequired,
         route:    React.PropTypes.object.isRequired
      }
   }

   static get defaultProps() {
      return {
         network: {}
      }
   }

   constructor() {
      super()

      this.state = {
         error:   null,
         loading: false
      }

      this.handleGrant = this.handleGrant.bind(this)
      this.handleRevoke = this.handleRevoke.bind(this)
      this.handleConfirmedRevoke = this.handleConfirmedRevoke.bind(this)
      this.redirectToParent = this.redirectToParent.bind(this)
   }

   handleGrant(ev) {
      // Remove entity from to `parent`
      ev.preventDefault()

      const {network} = this.props,
         {key} = network,
         parents = network.parents.concat(this.props.params.splat)

      this.setState({error: null, loading: true})

      return NetworkService.update(key, {parents})
         .catch(err => {
            Modal.error({
               title:   'Error Granting Access',
               content: 'Failed to grant access policies: ' + err.message
            })
            this.setState({loading: false})
         })
         .done(() => this.setState({loading: false}))
   }

   handleConfirmedRevoke(ev) {
      ev.preventDefault()

      Modal.confirm({
         title:      'Removing own access',
         content:    'You are about to revoke your own access to the network. Are you sure?',
         okText:     'Do it!',
         cancelText: 'Cancel',
         onOk:       () => this.handleRevoke(ev),
         onCancel:   () => null
      })
   }

   handleRevoke(ev) {
      // Remove entity from to `parent`
      ev.preventDefault()

      const {network} = this.props,
         {key} = network,
         parents = _.without(network.parents, this.props.params.splat)

      this.setState({error: null, loading: true})

      return NetworkService.update(key, {parents})
         .then(() => this.setState({loading: false}, this.redirectToParent))
         .catch(err => {
            Modal.error({
               title:   'Error Revoking Access',
               content: 'Failed to Revoking Access Policies: ' + err.message
            })
            this.setState({loading: false})
         })
   }

   redirectToParent() {
      const {router, routes, params, location} = this.props,
         parent = routes[routes.length - 2],
         basepath = _.dropRightWhile(location.pathname.split('/'), e => e !== parent.path).join('/')

      router.push({...location, pathname: basepath, query: {revoked: params.splat}})
   }

   render() {
      const {splat, nid} = this.props.params,
         [type, ...rest] = splat.split('/'),
         resource = rest.join('/'),
         hasAccess = _.contains(this.props.network.parents, splat),
         isSelf = splat === (AuthStore.auth || {}).owner,
         badge = !hasAccess
            ? <Badge status="error" text="Denied" />
            : <Badge status="success" text="Granted" />

      return (
         <div className="definitions">
            <div className="page-header">
               <h1>Access Policies for {type} {resource}</h1>

               <div className="actions">
                  {hasAccess &&
                     <Button
                        onClick={isSelf ? this.handleConfirmedRevoke : this.handleRevoke}
                        loading={this.state.loading}
                        type="danger"
                        icon="close"
                     >

                        Revoke Access Policies
                     </Button>}

                  {!hasAccess &&
                     <Button
                        onClick={this.handleGrant}
                        loading={this.state.loading}
                        type="primary"
                        icon="check"
                     >

                        Add Access Policies
                     </Button>}
               </div>
            </div>

            <div>
               <ul>
                  <li>
                     Resource <code>network/{nid}</code>
                     &nbsp;&nbsp;&nbsp;
                     {badge}
                  </li>
                  <li>
                     Resource <code>device/{nid}/ *</code>
                     &nbsp;&nbsp;&nbsp;
                     {badge}
                  </li>
                  <li>
                     Resource <code>message/{nid}/ *</code>
                     &nbsp;&nbsp;&nbsp;
                     {badge}
                  </li>
                  <li>
                     Resource <code>messages/{nid}/ *</code>
                     &nbsp;&nbsp;&nbsp;
                     {badge}
                  </li>
                  <li>
                     Resource <code>_channels/chan/{nid}/ *</code>
                     &nbsp;&nbsp;&nbsp;
                     {badge}
                  </li>
                  <li>
                     Resource <code>_channels/io/{nid}/ *</code>
                     &nbsp;&nbsp;&nbsp;
                     {badge}
                  </li>
                  <li>
                     Resource <code>_channels/tokens/{nid}/ *</code>
                     &nbsp;&nbsp;&nbsp;
                     {badge}
                  </li>
               </ul>
            </div>

            {'organization' === type &&
               <div style={{marginTop: '2em'}}>
                  <h5>
                     Users in {_.get(OrganizationStore.organization(resource), 'name', resource)}
                  </h5>
                  {OrganizationStore.organization(resource)
                     ? <div>
                          <ul>
                             {_.map(OrganizationStore.organization(resource).users, user => (
                                <li>{user}</li>
                             ))}
                          </ul>
                       </div>
                     : <Alert
                          style={{marginTop: '5px'}}
                          type="warning"
                          showIcon
                          message="Can't list users in organization: Access Denied"
                       />}
               </div>}
         </div>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/network/acl/SelectedACL.jsx